import { PipelineToolbar } from './toolbar';
import { PipelineUI } from './ui';
import { SubmitButton } from './submit';
import { ThemeProvider } from './themeContext';

function App() {
  return (
    <ThemeProvider>
      <div className="relative w-screen h-screen bg-light-bg dark:bg-dark-bg overflow-hidden flex flex-col transition-colors duration-300">
        <PipelineToolbar />
        <PipelineUI />
        <SubmitButton />
      </div>
    </ThemeProvider>
  );
}

export default App;
